import medianova from "./medianova"
import flussonic from "./flussonic"

class Cdn {
  constructor() {
    this.drivers = {
      medianova,
      flussonic
    }
  }

  async convert(url) {
    const driver = __.device.config("cdn.driver")
    return this.drivers[driver].convert(_$.splitUrl(url))
  }
}

export default new Cdn()
